import { HSOverlay } from "preline";

type SubscriptionStatusCallback = (isSubscriptionChanged: boolean | null) => void;

export const SubscriptionCtx = {
    modalIds: [] as string[],
    isSubscriptionChanged: false as boolean,
    isFromCtx: false as boolean,
    isFormSubscribeInitialized: false as boolean,
    isPageSubscribeInitialized: false as boolean,
    subscribers: [] as SubscriptionStatusCallback[],

    // Add a subscriber
    subscribe(callback: SubscriptionStatusCallback) {
        this.subscribers.push(callback);
        // Return an unsubscribe function
        return () => {
            this.unsubscribe(callback);
        };
    },

    // Remove a subscriber
    unsubscribe(callback: SubscriptionStatusCallback) {
        this.subscribers = this.subscribers.filter(sub => sub !== callback);
    },

    // Notify all subscribers
    notifySubscribers() {
        this.closeSubscriptionModal();
        this.subscribers.forEach(callback => callback(this.isSubscriptionChanged));
        this.subscribers = []
        this.isFromCtx = false;
    },

    setSubscriptionStatus(isSubscriptionChanged: boolean) {
        this.isSubscriptionChanged = isSubscriptionChanged;
        this.isFromCtx = true;
        this.notifySubscribers();
    },

    addModalId(modalId: string) {
        // check if already modalId in modalIds then return 
        if (this.modalIds.includes(modalId)) {
            return;
        }

        this.modalIds.push(modalId);
    },

    closeSubscriptionModal() {
        this.modalIds.forEach((modalId) => {
            const modalElem = document.querySelector(modalId) as HTMLElement;
            if (modalElem)
                HSOverlay.close(modalElem);
        });
        this.modalIds = [];
    }
}